<template>
  <PageWrapper :isLoading="isLoading">
    <template #title>
      ویرایش بج سواد
      {{ defaultTitle ? defaultTitle : "" }}
    </template>
    <BRow v-if="literacyBadgeDetails">
      <BCol cols="12">
        <TextInput
          inputId="title"
          inputLabel="عنوان بج"
          inputPlaceholder="A+"
          v-model="literacyBadgeDetails.title"
        ></TextInput>
      </BCol>

      <BCol cols="12" md="6">
        <CustomAppendText
          :isText="true"
          type="text"
          inputmode="numeric"
          customRules="required|min:1"
          inputId="userBasePricePercent"
          inputLabel="نسبت پرداختی زبان آموز به قیمت پایه (به درصد)"
          inputPlaceholder="30"
          v-model="literacyBadgeDetails.userBasePricePercent"
        >
          <template #append> % </template>
        </CustomAppendText>
      </BCol>

      <BCol cols="12" md="6">
        <CustomAppendText
          :isText="true"
          type="text"
          inputmode="numeric"
          customRules="required|min:1"
          inputId="masterBasePricePercent"
          inputLabel="نسبت درآمد استاد به قیمت پایه (به درصد)"
          inputPlaceholder="50"
          v-model="literacyBadgeDetails.masterBasePricePercent"
        >
          <template #append> % </template>
        </CustomAppendText>
      </BCol>

      <BCol cols="12">
        <BFormGroup label="تصویر نمایشی بج" label-for="imageFile">
          <BFormFile
            v-model="uploadImagePayload.imageFile"
            ref="imageFile"
            id="imageFile"
            accept=".jpg,.jpeg,.png"
            @input="handleImageFile"
          ></BFormFile>
        </BFormGroup>
      </BCol>

      <BCol cols="12" class="position-relative" v-if="imagePreview">
        <BImg
          v-if="imagePreview"
          rounded
          class="custom-image"
          center
          fluid
          :src="imagePreview"
        ></BImg>
        <BButton
          size="sm"
          variant="transparent"
          class="custom-delete-btn"
          @click="deletePreviewImage"
        >
          <FeatherIcon size="40" class="text-danger" icon="Trash2Icon" />
        </BButton>
      </BCol>

      <BCol cols="12" class="mt-1">
        <label> تصویر فعلی بج </label>
        <div class="d-flex align-items-center justify-content-center">
          <BImg
            rounded
            class="custom-image mx-auto"
            fluid
            :src="defaultImage"
          ></BImg>
        </div>
      </BCol>

      <BCol cols="12">
        <CustomTextarea
          rows="3"
          inputId="desc"
          inputLabel="توضیحات بج"
          inputPlaceholder="توضیحات..."
          :maxChars="3000"
          customRules="max:3000"
          :charsCount="
            literacyBadgeDetails.description
              ? literacyBadgeDetails.description.length
              : 0
          "
          v-model="literacyBadgeDetails.description"
        ></CustomTextarea>
      </BCol>
      <BCol cols="12" class="d-flex align-items-center justify-content-end">
        <BButton @click="sendUpdateLiteracytBadgeRequest" variant="success">
          ویرایش
        </BButton>
      </BCol>
    </BRow>
  </PageWrapper>
</template>
<script>
export default {
  mounted() {
    this.getLiteracyBadgeDetails();
  },
  data() {
    return {
      isLoading: false,
      literacyBadgeDetails: null,
      uploadImagePayload: {
        imageFile: null,
        fileType: 0,
        title: null,
        alt: null,
        description: null,
      },
      imagePreview: null,
      defaultImage: null,
      defaultTitle: null,
    };
  },
  methods: {
    async getLiteracyBadgeDetails() {
      try {
        this.isLoading = true;
        const _this = this;
        const getALiteracyBadge = new GetALiteracyBadge(_this);
        getALiteracyBadge.setRequestParam({
          id: _this.$route.params.id,
        });
        await getALiteracyBadge.fetch((res) => {
          _this.literacyBadgeDetails = res.data;
          _this.defaultImage = res.data.imageUrl;
          _this.defaultTitle = res.data.title;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async sendUpdateLiteracytBadgeRequest() {
      try {
        this.isLoading = true;
        if (this.uploadImagePayload.imageFile) {
          await this.uploadLiteracyBadgeImage();
        }
        const _this = this;
        const updateALiteracyBadge = new UpdateALiteracyBadge(_this);
        _this.literacyBadgeDetails["id"] = +_this.$route.params.id;
        updateALiteracyBadge.setRequestParamDataObj(_this.literacyBadgeDetails);
        await updateALiteracyBadge.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "بج سواد با موفقیت ویرایش شد.",
              },
            });
            if (_this.imagePreview) {
              _this.deletePreviewImage();
            }
            _this.getLiteracyBadgeDetails();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    // async createANewLiteracyBadgeRequest() {
    //   try {
    //     this.isLoading = false;
    //     if (this.uploadImagePayload.imageFile) {
    //       await this.uploadLiteracyBadgeImage();
    //     }
    //     const _this = this;
    //     const createALiteracyBadge = new CreateALiteracyBadge(_this);
    //     createALiteracyBadge.setRequestParamDataObj(_this.literacyBadgeDetails);
    //     await createALiteracyBadge.fetch((res) => {
    //       if (res.isSuccess) {
    //         _this.$toast({
    //           component: ToastificationContent,
    //           props: {
    //             title: "ایجاد شد!",
    //             icon: "CheckIcon",
    //             variant: "success",
    //             text: "کلاس ترمیک با موفقیت ایجاد شد.",
    //           },
    //         });
    //         if (_this.imagePreview) {
    //           _this.deletePreviewImage();
    //         }
    //         _this.literacyBadgeDetails = {
    //           title: null,
    //           description: null,
    //           masterBasePricePercent: null,
    //           userBasePricePercent: null,
    //           imageUrl: null,
    //         };
    //       } else {
    //         _this.$toast({
    //           component: ToastificationContent,
    //           props: {
    //             title: "ایجاد نشد!",
    //             icon: "XIcon",
    //             variant: "danger",
    //             text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
    //           },
    //         });
    //       }
    //       console.log(res);
    //     });
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },

    async uploadLiteracyBadgeImage() {
      try {
        this.isLoading = true;
        const _this = this;
        const uploadImage = new UploadImage(_this);
        uploadImage.setFormData(await _this.generateImageFormData());
        await uploadImage.sendFormData((res) => {
          if (res.data.url) {
            _this.literacyBadgeDetails.imageUrl = res.data.url;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async generateImageFormData() {
      return new Promise((resolve, reject) => {
        this.uploadImagePayload.title = this.literacyBadgeDetails.title;
        this.uploadImagePayload.alt = this.literacyBadgeDetails.title;
        this.uploadImagePayload.description =
          this.literacyBadgeDetails.description;

        const myFormData = new FormData();
        Object.keys(this.uploadImagePayload).forEach((key) => {
          myFormData.append(key, this.uploadImagePayload[key]);
        });
        resolve(myFormData);
      });
    },
    deletePreviewImage() {
      if (this.uploadImagePayload && this.uploadImagePayload.imageFile) {
        URL.revokeObjectURL(this.imagePreview);
        this.imagePreview = null;
        this.uploadImagePayload.imageFile = null;
        if (this.$refs.imageFile) {
          this.$refs.imageFile.reset();
        }
      }
    },
    handleImageFile() {
      if (this.uploadImagePayload.imageFile) {
        this.imagePreview = URL.createObjectURL(
          this.uploadImagePayload.imageFile
        );
      }
    },
  },
  components: {
    PageWrapper,
    TextInput,
    CustomAppendText,
    CustomTextarea,
    BCol,
    BRow,
    BImg,
    BButton,
    BFormGroup,
    BFormFile,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import CustomTextarea from "@/views/components/Utils/CustomTextarea.vue";
import {
  BCol,
  BRow,
  BImg,
  BButton,
  BFormGroup,
  BFormFile,
} from "bootstrap-vue";
import {
  GetALiteracyBadge,
  UpdateALiteracyBadge,
} from "@/libs/Api/LiteracyBadge";
import { UploadImage } from "@/libs/Api/Uploader";
</script>

<style scoped>
.custom-image {
  max-height: 200px;
}
.custom-delete-btn {
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
}
</style>
